export default "__VITE_ASSET__nLZUqzQc__"